import React from 'react';

import useScreenOrientation from './helpers/useScreenOrientation';

import introTitle from "../assets/images/Tittle_Top10.png";
import iconTime from "../assets/images/Icon_Reloj.png";
import iconScore from "../assets/images/Icon_Star.png";

export default function TopResults({ isVisible, setView, topScores }: any) {

  const isLandscape = useScreenOrientation();

  const formatTime = (value: number) => {
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = Math.floor(value % 60);
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  const formatName = (value: string) => {
    if(value.length > 10)
      return value.substring(0,7) + "..."
    return value;
  }

  const showExit = () => {
    setView("Intro")
  };

  return (
    <div className={`full-topresults-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`topresults-container ${isLandscape ? '' : 'portrait'}`}>

        <img className={`topresults-container-header ${isLandscape ? '' : 'portrait'}`} src={introTitle} alt=''/>
        <div className={`topresults-container-grid ${isLandscape ? '' : 'portrait'}`}>
          {
            (topScores.top).map((userData: any, index: number) =>
              <div key={`topresults ${index}`} className="topresults-item-container">
                <div className={`topresults-item-text-rank ${isLandscape ? '' : 'portrait'}`}>{index + 1}</div>
                <div className={`topresults-item-text-name ${isLandscape ? '' : 'portrait'}`}><div>{formatName(userData.name)}</div></div>
                <div className={`topresults-item-text-space ${isLandscape ? '' : 'portrait'}`}></div>
                <div className={`topresults-item-icon ${isLandscape ? '' : 'portrait'}`}><img className={`topresults-item-icon-img ${isLandscape ? '' : 'portrait'}`} src={iconScore} alt=''/></div>
                <div className={`topresults-item-text-results ${isLandscape ? '' : 'portrait'}`}>{userData.point}</div>
                <div className={`topresults-item-icon ${isLandscape ? '' : 'portrait'}`}><img className={`topresults-item-icon-img ${isLandscape ? '' : 'portrait'}`} src={iconTime} alt=''/></div>
                <div className={`topresults-item-text-results ${isLandscape ? '' : 'portrait'}`}>{formatTime(userData.time)}</div>
              </div>
            )
          }
        </div>

        <div className="topresults-buttons">
          <div className="topresults-button-container exit" onClick={() => showExit()} >
            <div className={`topresults-button-text ${isLandscape ? '' : 'portrait'}`}>SALIR</div>
          </div>
        </div>

      </div>
    </div>
  );
}